export function GermanFlag(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" {...props} viewBox="0 0 512 512">
      <mask id="a">
        {/* theme-ok: SVG mask, white means visible */}
        <circle cx="256" cy="256" r="256" fill="#fff" />
      </mask>
      <g mask="url(#a)">
        {/* theme-ok: national flag colours */}
        <path fill="#ffda44" d="m0 345 256.7-25.5L512 345v167H0z" />
        {/* theme-ok: national flag colours */}
        <path fill="#d80027" d="m0 167 255-23 257 23v178H0z" />
        {/* theme-ok: national flag colours */}
        <path fill="#333" d="M0 0h512v167H0z" />
      </g>
    </svg>
  )
}
